export default {
      id: "trilliant-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#trilliant",
      toString: function () {
        return this.url;
      }
    }